//新闻
//父级页面
const News = () => import("../views/news/news.vue")
//新闻首页
const NewsHome = () => import("../views/news/news_home.vue")
//头条新闻
const NewsHeadlines = () => import("../views/news/news_headlines/news_headlines.vue")
const NewsHeadlinesList = () => import("../views/news/news_headlines/news_headlines_list.vue")
//专题新闻
const NewsTopic = () => import("../views/news/news_topic/news_topic.vue")
const NewsTopicAll = () => import("../views/news/news_topic/news_topic_all.vue")
const NewsTopicList = () => import("../views/news/news_topic/news_topic_list.vue")
//综合新闻
const NewsComposite = () => import("../views/news/news_composite/news_composite.vue")
const NewsCompositeList = () => import("../views/news/news_composite/news_composite_list.vue")
//新闻详情页
const NewsDetail = () => import("../views/news/news_detail.vue")
//优秀学校
const NewsSchool = () => import("../views/news/news_school/news_school.vue")
const NewsSchoolList = () => import("../views/news/news_school/news_school_list.vue")
const NewsSchoolDetail = () => import("../views/news/news_school/news_school_detail.vue")
//优秀学员
const NewsStudent = () => import("../views/news/news_students/news_student.vue")
const NewsStudentList = () => import("../views/news/news_students/news_student_list.vue")
const NewsStudentDetail = () => import("../views/news/news_students/news_student_detail.vue")
const NewsStyleDetail = () => import("../views/news/news_students/news_style_detail.vue")
//优秀课程
const NewsCourse = () => import("../views/news/news_course/news_course.vue")
const NewsCourseList = () => import("../views/news/news_course/news_course_list.vue")
const NewsCourseDetail = () => import("../views/news/news_course/news_course_detail.vue")

import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

export default [
  {
    path: '/news',
    name: 'news',
    component: News,
    redirect:{name:'newsHome'},
    meta: {
      title:""
      // keepAlive: true
    },
    children:[
      {
        path: '/',
        name: 'newsHome',
        component: NewsHome,
        meta: {
          title:"新闻首页"
          // keepAlive: true
        }
      },
      {
        path: '/news/headlines',
        name: 'headlines',
        component: NewsHeadlines,
        meta: {
          title: "新闻头条"
        },
        redirect:{name:'headlinesList'},
        children:[
          {
            path: '',
            name: 'headlinesList',
            component: NewsHeadlinesList,
          },
          {
            path: 'detail/:id',
            name: 'Detail',
            component: NewsDetail,
            meta:{
              title:"新闻详情"
            }
          }
        ]
      },
      {
        path: '/news/topic',
        name: 'topic',
        component: NewsTopic,
        meta:{
          title:"专题新闻"
        },
        redirect:{name:'topicAll'},
        children:[
          {
            path: '',
            name: 'topicAll',
            component: NewsTopicAll,
            // meta:{
            //   title:"专题新闻"
            // }
          },
          {
            path: 'list/:id',
            name: 'topiclist',
            component: NewsTopicList,
            meta:{
              title:"专题列表"
            }
          },
          {
            path: 'detail/:id',
            name: 'topicDetail',
            component: NewsDetail,
            meta:{
              title:"新闻详情"
            }
          }
        ]
      },
      {
        path: '/news/composite',
        name: 'composite',
        component: NewsComposite,
        meta:{
          title:"综合新闻"
        },
        redirect:{name:'headlinesList'},
        children:[{
            path: '',
            name: 'compositeList',
            component: NewsCompositeList,
          },
          {
            path: 'detail/:id',
            name: 'compsiteDetail',
            component: NewsDetail,
            meta:{
              title:"新闻详情"
            }
          }
        ]
      },
      {
        path: '/news/school',
        name: 'school',
        component: NewsSchool,
        meta:{
          title:"学校风采"
        },
         redirect:{name:'schoolList'},
         children:[
          { 
            path: '',
            name: 'schoolList',
            component: NewsSchoolList,
          },{
           path: 'detail/:id',
           name: 'schoolDetail',
           component: NewsSchoolDetail,
           meta:{
             title:"学校详情"
           }
         }]
      },
      {
        path: '/news/student',
        name: 'student',
        component: NewsStudent,
        meta:{
          title:"学员风采"
        },
        redirect:{name:'studentList'},
        children:[
          { 
            path: '',
            name: 'studentList',
            component: NewsStudentList,
          },
          {
            path: 'detail/:id',
            name: 'studentDetail',
            component: NewsStudentDetail,
            meta:{
              title:"学员详情"
            }
          },
          {
            path: '/news/style/detail/:id',
            name: 'styleDetail',
            component: NewsStyleDetail,
            meta:{
              title:"学员成果"
            }
          }
        ]
      },
      {
        path: '/news/course',
        name: 'course',
        component: NewsCourse,
        meta:{
          title:"优秀课程"
        },
        redirect:{name:'courseList'},
        children:[
          { 
            path: '',
            name: 'courseList',
            component: NewsCourseList,
         },{ 
           path: 'detail/:id',
           name: 'courseDetail',
           component: NewsCourseDetail,
           meta:{
             title:"课程详情"
           }
        }]
      }
    ]
  },
]
